export function shortenAddress(address) {
  if (!address || address.length < 10) return address || "";
  return `${address.slice(0, 6)}…${address.slice(-4)}`;
}

export function fmtMessage(template, vars = {}) {
  let s = template || "";
  Object.keys(vars).forEach((key) => {
    s = s.split(`{${key}}`).join(String(vars[key]));
  });
  return s;
}
